import { useMemo } from 'react';
import { IconName } from '../../Icon.types';
import * as Icon from '../../assests';
export const useIcon = (name) => {
    const icon = useMemo(() => {
        const icon = {
            [IconName.LOCATION]: Icon.Location,
            [IconName.ADD]: Icon.Add,
            [IconName.BAN]: Icon.Ban,
            [IconName.BRIEFCASE]: Icon.Briefcase,
            [IconName.BUSINESS]: Icon.Business,
            [IconName.CALENDAR]: Icon.Calendar,
            [IconName.MULTIPLY]: Icon.Multiply,
            [IconName.REMOVE]: Icon.Remove,
            [IconName.USERS]: Icon.Users,
            [IconName.CHECK]: Icon.Check,
            [IconName.SPINNER]: Icon.Spinner,
            [IconName.BILLS]: Icon.Bills,
            [IconName.VERIFIED_FILL]: Icon.VerifiedFill,
            [IconName.SITEMAP]: Icon.Sitemap,
            [IconName.SLIDERS]: Icon.Sliders,
            [IconName.SHIELD]: Icon.Shield,
            [IconName.CARET_DOWN]: Icon.CaretDown,
            [IconName.CIRCLE_QUESTION]: Icon.CircleQuestion,
            [IconName.CHEVRON_DOWN]: Icon.ChevronDown,
        }[name];
        if (!icon) {
            console.error(`Icon ${name} not found`);
            return Icon.CircleQuestion;
        }
        return icon;
    }, [name]);
    return icon;
};
